export default __webpack_public_path__ + "static/media/furyofxotli.7fbeddf8.png";